/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TestIntegrationConnectionResponseDto = {
    errorMessages: Array<string>;
    status: TestIntegrationConnectionResponseDto.status;
    successMessages: Array<string>;
    warningMessages: Array<string>;
};

export namespace TestIntegrationConnectionResponseDto {

    export enum status {
        SUCCESS = 'SUCCESS',
        WARNING = 'WARNING',
        ERROR = 'ERROR',
    }


}
